'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'bug';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f188';
var svgPathData = ['M176 224l0 128c0 53.6 37.7 98.4 88 109.4l0-189.4 48 0 0 189.4c50.3-11 88-55.8 88-109.4l0-128-224 0z', 'M288 0c53 0 96 43 96 96l0 32-192 0 0-32c0-53 43-96 96-96zM400 352l0-128-224 0 0 128c0 53.6 37.7 98.4 88 109.4l0-189.4 48 0 0 189.4c50.3-11 88-55.8 88-109.4zM128 204C59.2 152.4 24 126 22.4 124.8l28.8-38.4 19.2 14.4 100.3 75.2 234.7 0 100.3-75.2 19.2-14.4 28.8 38.4C552 126 516.8 152.4 448 204l0 60 128 0 0 48-128 0 0 40c0 6.5-.4 12.9-1.1 19.1 69.8 52.3 105.3 79 106.7 80.1l-28.8 38.4c-3.8-2.9-34.6-25.9-92.2-69.1-25.7 54.1-80.8 91.5-144.6 91.5s-119-37.4-144.6-91.5C85.8 463.7 55 486.7 51.2 489.6L22.4 451.2c1.4-1.1 37-27.7 106.7-80.1-.7-6.3-1.1-12.7-1.1-19.1l0-40-128 0 0-48 128 0 0-60z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;